import React from 'react'
import './TermsOfUse.css'

export default function TermsOfUse() {
    return (
        <div className="termsContainer">
            <h1>Disclaimer</h1>
            <p>
                The information and content provided by us ("Althub Inc", "us", "we") have been collected and gathered from various publicly available sources and other third party sources.
            </p>
            <p>
                We provide the platform and content on an "as is" and "as available" basis, without any warranty of any kind.
            </p>
            <p>
                Amongst other, we expressly disclaim all warranties, whether express, implied or statutory, regarding the platform and its content including without limitation any warranty of merchantability, fitness for a particular purpose, title, security, and non-infringement.
            </p>
            <p>
                No warranties or representations are given, and no liability is accepted, by Althub Inc in relation to the accuracy, quality, lawfulness, integrity, fairness or completeness of the content or the third party sources.
            </p>
            <p>
                You expressly agree that you assume full responsibility for your use of the platform and its content.
            </p>
        </div>
    )
}